// extracted by mini-css-extract-plugin
module.exports = {"heading":"community-spec-invite_heading__wkTnI","bodyText":"community-spec-invite_bodyText__oo_qo"};